import { render, staticRenderFns } from "./RightSide.vue?vue&type=template&id=1f4eb07e&scoped=true&"
import script from "./RightSide.vue?vue&type=script&lang=js&"
export * from "./RightSide.vue?vue&type=script&lang=js&"
import style0 from "./RightSide.vue?vue&type=style&index=0&id=1f4eb07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4eb07e",
  null
  
)

export default component.exports